// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rS8C","name":"styles_name__shsQa","phone":"styles_phone__16e5t"};